
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/errors/institution",
      function () {
        return require("private-next-pages/docs/errors/institution.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/errors/institution"])
      });
    }
  